import * as React from 'react';
import cx from 'classnames';
import { IGlyph, Icon } from '@treelab/panda';

/**
 * The Icon Component within a Bar. It has the option of being a button or not.
 */
export interface IBarIconProps {
  /** Passed down classname. */
  className?: string;
  /** Glyph for svg */
  icon: IGlyph;
  /** Custom size if needed */
  iconSize?: { height?: number; width?: number };
  /** Make the Button small. */
  isSmall?: boolean;
  /** Button has a white outline and text, the background color is dependant on parent */
  isReverse?: boolean;
  /** Button is disabled */
  isDisabled?: boolean;
  /** On click action for the button. */
  onClick?: (e: React.MouseEvent) => void;
}

export const BarIcon: React.FC<IBarIconProps> = ({
  className,
  isSmall = false,
  isReverse = false,
  isDisabled = false,
  icon,
  iconSize,
  onClick,
}) => {
  const combinedClass = cx({
    'panda-bar-item': true,
    'flex-center': true,
    'hover-cursor': !!onClick && !isDisabled,
    // Reverse style
    'panda-bar-item-normal': !isReverse,
    'panda-bar-item-reverse': isReverse,
    'panda-bar-item-disabled': isDisabled,
    'panda-bar-item-button': !!onClick,
    // Custom classname
    [className || '']: true,
  });

  if (onClick) {
    return (
      <button
        className={combinedClass}
        onClick={isDisabled ? () => ({}) : (e) => onClick(e)}
        type="button"
      >
        <Icon icon={icon} size={iconSize || { height: isSmall ? 15 : 18 }} />
      </button>
    );
  }

  return (
    <div className={combinedClass}>
      <Icon icon={icon} size={iconSize || { height: isSmall ? 15 : 18 }} />
    </div>
  );
};
